import styled from 'styled-components';

import { pxToRem } from '@utils/converters';

export const OptionIconWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  height: pxToRem(24),
  flexShrink: 0,
});

export const OptionLabelWrapper = styled.span({
  paddingTop: pxToRem(2),
});
